module.exports = __webpack_public_path__ + "img/94.09c55808.jpg";